import { Form } from '@unform/web';
import React, { useState } from 'react';
import { FaAngleDoubleUp } from 'react-icons/fa';
import { Alert } from '../Alert';
import { Loading } from '../Loading';
import FURGAPI from './../../services/api.furg';
import { getToken } from './../../services/auth';
import { decodeHexHtmlCharCodes, formattedDate } from './../../services/utils';
import FileList from './../Forms/FileList';
import Preview from './../Forms/FileList/Preview';
import { DocumentoHeader } from './DocumentoHeader';

const DocumentoArquivos = ({ tipo_envio, documentacao_aceita = '', documentacao_parecer = '', recurso_parecer = '', ...props }) => {
    const {
        id_tipo_documento_candidato: id,
        tx_tipo_documento: descricao,
        recurso_aceito,
        arquivos_recurso,
        nr_protocolo_recurso: protocolo_recurso,
        dt_envio: data_envio,
        nr_protocolo: protocolo,
        dt_envio_recurso,
        arquivos,
    } = props;
    const leitura = 'N' !== tipo_envio;

    const getStatus = ({ protocolo, aceite, parecer, data_envio, dentroPeriodo = false, recurso_aceito }) => {
        if (aceite === 'N') {
            return {
                situacao: 'danger',
                alerta: (
                    <Alert variant={recurso_aceito === 'S' ? 'dark' : 'danger'} icon={false}>
                        {protocolo ? (
                            <>
                                <b>Protocolo:</b> {protocolo} <br />
                                <b>Data de envio:</b> {formattedDate(data_envio)} <br />
                            </>
                        ) : (
                            <>
                                <b>Protocolo:</b> Não tem protocolo <br />
                            </>
                        )}
                        <b>Avaliação: </b> Documentação indeferida pela comissão avaliadora <br />
                        <b>Parecer: </b> {parecer}
                        {protocolo && <FaAngleDoubleUp style={{ position: 'absolute', bottom: 10, right: 10 }} />}
                    </Alert>
                ),
            };
        }

        if (!protocolo) {
            return {
                situacao: 'warning',
                alerta: (
                    <Alert variant="warning" icon={false}>
                        {dentroPeriodo ? (
                            <>
                                Documento sem comprovação ou declaração não finalizada.
                                <FaAngleDoubleUp style={{ position: 'absolute', bottom: 10, right: 10 }} />
                            </>
                        ) : (
                            'Você não enviou nenhum documento comprobatório'
                        )}
                    </Alert>
                ),
            };
        }

        return {
            situacao: 'success',
            alerta: (
                <Alert variant="success" icon={false}>
                    <b>Protocolo:</b> {protocolo} <br />
                    <b>Data de envio:</b> {formattedDate(data_envio)}
                    {'S' === aceite && (
                        <>
                            <br />
                            <b>Avaliação:</b> Documentação <b>aceita e deferida</b> pela comissão avaliadora
                        </>
                    )}
                    <FaAngleDoubleUp style={{ position: 'absolute', bottom: 10, right: 10 }} />
                </Alert>
            ),
        };
    };

    let { situacao, alerta } = getStatus({ protocolo, aceite: documentacao_aceita, parecer: documentacao_parecer, tipo_envio: tipo_envio === 'N', data_envio, recurso_aceito });
    const { situacao: situacaoParecer, alerta: alertaParecer } = getStatus({
        protocolo: protocolo_recurso,
        aceite: recurso_aceito,
        parecer: recurso_parecer,
        tipo_envio: tipo_envio === 'R',
        data_envio: dt_envio_recurso,
    });
    if (documentacao_aceita === 'N') {
        situacao = situacaoParecer;
    }

    return (
        <div className="row">
            <div className="d-flex col-12">
                <div className="flex-fill w-100 card">
                    <div className="card-header card-header--alert">
                        <DocumentoHeader type={situacao}>{descricao}</DocumentoHeader>
                    </div>

                    <div className="card-body">
                        {/* <> Tipo normal */}
                        <>
                            <div
                                className={'accordion accordion--alert ' + (arquivos.length > 0 && protocolo ? 'collapsed' : '')}
                                data-toggle="collapse"
                                data-target={'#doc_' + id}
                                aria-expanded="true"
                                aria-controls="collapse"
                            >
                                <div className="accordion-title">Primeira fase</div>
                                {alerta}
                            </div>

                            <div id={'doc_' + id} className={'accordion-body collapse ' + (arquivos.length > 0 && protocolo ? '' : 'show')} aria-labelledby="headingOne">
                                <DocumentoPrimeiraEtapa {...props} leitura={leitura} />
                            </div>
                        </>

                        {/* <> Tipo recurso */}
                        {documentacao_aceita === 'N' && (
                            <>
                                <div
                                    className={'accordion accordion--alert ' + (arquivos.length > 0 && protocolo ? 'collapsed' : '')}
                                    data-toggle="collapse"
                                    data-target={'#doc_recurso_' + id}
                                    aria-expanded="true"
                                    aria-controls="collapse"
                                >
                                    <div className="accordion-title">Complementação da documentação</div>
                                    {alertaParecer}
                                </div>
                                <div id={'doc_recurso_' + id} className={'accordion-body collapse' + (arquivos_recurso.length > 0 && protocolo_recurso ? '' : 'show')} aria-labelledby="headingOne">
                                    <DocumentoRecurso {...props} leitura={'R' !== tipo_envio || recurso_aceito === 'S'} />
                                </div>
                            </>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

const DocumentoPrimeiraEtapa = ({ id_tipo_documento_candidato: id, tp_arquivos_aceitos, onUpdate, leitura = false, vestibular, dt_envio: data_envio, nr_protocolo: protocolo, arquivos }) => {
    const [situacao, setSituacao] = useState(!!protocolo);
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);

    const handleSubmit = data => {
        if (leitura) return;
        setError('');
        setLoading(true);
        FURGAPI.call('sischamamentos/Publico/gerarProtocoloEnvio', {
            token: getToken(vestibular),
            id_tipo_documento_candidato: id,
            key: data.keys,
        })
            .then(res => {
                onUpdate(id, res);
                setSituacao(true);
                setLoading(false);
            })
            .catch(error => {
                setError(decodeHexHtmlCharCodes(error));
                setSituacao(false);
                setLoading(false);
            });
    };

    const handleReenviarDocumentos = () => {
        if (leitura) return;
        onUpdate(id, { arquivos: [] });
        setSituacao(false);
    };

    if (situacao || !leitura) {
        return (
            <>
                <div id={'#accordion' + id}>
                    {arquivos.length > 0 && (
                        <>
                            <div style={{ fontSize: '.9em' }} className="mb-2">
                                {arquivos.length} documento(s) recebido(s)
                            </div>
                            <div className="d-flex" style={{ flexWrap: 'wrap' }}>
                                {arquivos.map((arquivo, index) => (
                                    <Preview key={index} index={index} modoLeitura={true} arquivo={{ preview: arquivo.thumb }}></Preview>
                                ))}
                            </div>
                        </>
                    )}

                    <div className="accordion__rodape text-center mt-3">
                        {loading && <Loading />}
                        <Form onSubmit={handleSubmit}>
                            {!situacao && !leitura && <FilePreviewResource id={id} error={error} tipos_arquivos_aceitos={tp_arquivos_aceitos} />}
                            {situacao && (
                                <ConfirmacaoEnvioRecebido periodo="Primeira etapa" protocolo={protocolo} data_envio={data_envio} leitura={leitura} onEnviarDocumento={handleReenviarDocumentos} />
                            )}
                        </Form>
                    </div>
                </div>
            </>
        );
    }

    return <></>;
};

const DocumentoRecurso = ({
    id_tipo_documento_candidato: id,
    tp_arquivos_aceitos,
    onUpdate,
    leitura = false,
    vestibular,
    dt_envio_recurso: data_envio,
    nr_protocolo_recurso: protocolo,
    arquivos_recurso: arquivos,
}) => {
    const [situacao, setSituacao] = useState(!!protocolo);
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);

    const handleSubmit = data => {
        if (leitura) return;
        setError('');
        setLoading(true);
        FURGAPI.call('sischamamentos/Publico/gerarProtocoloEnvio', {
            token: getToken(vestibular),
            id_tipo_documento_candidato: id,
            key: data.keys,
        })
            .then(res => {
                onUpdate(id, { dt_envio_recurso: res.dt_envio, nr_protocolo_recurso: res.nr_protocolo, arquivos_recurso: res.arquivos });
                setSituacao(true);
                setLoading(false);
            })
            .catch(error => {
                setError(decodeHexHtmlCharCodes(error));
                setSituacao(false);
                setLoading(false);
            });
    };

    const handleReenviarDocumentos = () => {
        if (leitura) return;
        onUpdate(id, { arquivos_recurso: [] });
        setSituacao(false);
    };

    if (situacao || !leitura) {
        return (
            <>
                {arquivos.length > 0 && (
                    <>
                        <div style={{ fontSize: '.9em' }} className="mb-2">
                            {arquivos.length} documento(s) recebido(s)
                        </div>
                        <div className="d-flex" style={{ flexWrap: 'wrap' }}>
                            {arquivos.map((arquivo, index) => (
                                <Preview key={index} index={index} modoLeitura={true} arquivo={{ preview: arquivo.thumb }} />
                            ))}
                        </div>
                    </>
                )}

                <div className="accordion__rodape text-center mt-3">
                    {loading && <Loading />}
                    <Form onSubmit={handleSubmit}>
                        {!situacao && !leitura && <FilePreviewResource id={id} error={error} tipos_arquivos_aceitos={tp_arquivos_aceitos} />}
                        {situacao && (
                            <ConfirmacaoEnvioRecebido
                                periodo="Complementação da documentação"
                                protocolo={protocolo}
                                data_envio={data_envio}
                                leitura={leitura}
                                onEnviarDocumento={handleReenviarDocumentos}
                            />
                        )}
                    </Form>
                </div>
            </>
        );
    }

    return <></>;
};

const FilePreviewResource = ({ id, error, tipos_arquivos_aceitos }) => {
    const [podeConfirmarEnvio, setPodeConfirmarEnvio] = useState(false);

    return (
        <>
            {error && (
                <div className="text-left">
                    <Alert variant="danger">{error}</Alert>
                </div>
            )}
            <FileList
                id_documento={id}
                tipos_arquivos_aceitos={tipos_arquivos_aceitos}
                onPodeConfirmarEnvio={valor => {
                    setPodeConfirmarEnvio(valor);
                }}
            />
            <button disabled={podeConfirmarEnvio ? '' : 'disabled'} className="btn btn-primary">
                Confirmar envio
            </button>
        </>
    );
};

const ConfirmacaoEnvioRecebido = ({ periodo, protocolo, data_envio, leitura, onEnviarDocumento }) => (
    <>
        {!leitura && (
            <>
                <p className="mt-3">Caso você queira alterar os documentos enviados e gerar um novo protocolo, pressione o botão "Reenviar documentos" abaixo.</p>
                <hr />
                <button type="button" className="btn btn-primary" data-toggle="modal" data-target={`#reenviar_modal_${protocolo}`}>
                    Reenviar documentos
                </button>
                <div className="modal fade" id={`reenviar_modal_${protocolo}`} tabIndex="-1" role="dialog">
                    <div className="modal-dialog" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">Atenção</h5>
                                <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div className="modal-body">
                                <p>Ao reenviar novos outros documentos, os enviados anteriormente serão desconsiderados</p>
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-outline-secondary order-1 order-sm-0" data-dismiss="modal">
                                    Cancelar
                                </button>
                                <button type="button" className="btn btn-primary order-0 order-sm-1" data-dismiss="modal" onClick={() => onEnviarDocumento()}>
                                    Continuar
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        )}
    </>
);

export default DocumentoArquivos;
